// Moved out of pages/CanvasUI.tsx unchanged (Threads split).

export type PendingActionDecisionResult = {
  actionId: number;
  status: 'approved' | 'cancelled';
  summary?: string | null;
  correlationId?: string | null;
};

export type PendingActionErrorState = {
  message: string;
  correlationId?: string;
  code?: string;
};

export interface EditSelection {
  messageId: number;
  text: string;
  rect: { top: number; left: number };
}

export interface ThreadReplayContextSummary {
  header?: string | null;
  scope?: string | null;
  chatProjectId?: number | null;
  projectName?: string | null;
  projectType?: string | null;
  hasGlobalCards?: boolean;
}

export interface ReplayToolExecution {
  toolName: string;
  status: string;
  stepId?: string;
  resultPreview?: string | null;
  error?: string | null;
  isPartial?: boolean;
  isFinal?: boolean;
  cached?: boolean;
  metadata?: Record<string, unknown> | null;
}

export interface OrchestrationPlanSummary {
  reasoning?: string;
  steps?: Array<{
    id?: string;
    parallel?: boolean;
    tools?: Array<{ tool?: string }>;
  }>;
  synthesisStrategy?: string;
  degraded?: boolean;
}

export interface ReplayRecord {
  assistantMessageId: number;
  sanitizedUserInput?: string | null;
  injectedContext?: ThreadReplayContextSummary | null;
  plannerProvider?: string | null;
  plannerModel?: string | null;
  plannerLatencyMs?: number | null;
  plannerAttempt?: number | null;
  plannerDegraded?: boolean | null;
  decision?: Record<string, unknown> | null;
  toolRouting?: Record<string, unknown> | null;
  orchestrationPlan?: OrchestrationPlanSummary | null;
  toolExecutions?: ReplayToolExecution[] | null;
  fallbackReason?: string | null;
  degradedReason?: string | null;
  requestId?: string | null;
  finalMetadata?: Record<string, unknown> | null;
  feedback?: Array<{ rating: number; comment?: string | null }>;
}

export const normalizeIdentifier = (value: any): string =>
  value === undefined || value === null ? '' : String(value);

export const coerceNumericId = (value: any): number | null => {
  if (typeof value === 'number' && Number.isFinite(value)) return value;
  if (typeof value === 'string') {
    const parsed = Number(value);
    if (Number.isFinite(parsed)) return parsed;
  }
  return null;
};
